// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme-orange .v-expansion-panel-title[data-v-5a34169f] {\n        background-color: #e79925 !important;\n        color: white !important;\n}\n.theme-orange .v-expansion-panel-text[data-v-5a34169f] {\n        background-color: #fff7eb !important;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
